import React from 'react';

export default function bin() {
  return (
    <svg width="18" viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#bin-clip665)">
        <path
          d="M6 0.36377V1.36377H1V3.36377H2V16.3638C2 17.4683 2.89543 18.3638 4 18.3638H14C15.1046 18.3638 16 17.4683 16 16.3638V3.36377H17V1.36377H12V0.36377H6ZM4 3.36377H14V16.3638H4V3.36377ZM6 5.36377V14.3638H8V5.36377H6ZM10 5.36377V14.3638H12V5.36377H10Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="bin-clip665">
          <path d="M0 0.36377H18V18.3638H0V0.36377Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
